import {PHASES} from "../../../constants/phases";
import {selectPhase, selectUnits} from "../../../redux/reducers/sharedStateReducer/selectors";

/**
 * Какие отряды только что погибли от голода: конец фазы снабжения убирает отряды, чей размер
 * упал до нуля (см. редьюсер, COMPLETE_PHASE). Новобранец крысолюдов за снабжение сюда не
 * относится: если снабжения он так и не получил, то на поле и не появлялся.
 *
 * @param {Object} prevState — состояние до экшена
 * @param {Object} state
 * @param {Object} action
 * @returns {Object[]} отряды в том виде, какими они стояли на поле
 */
export const resolveStarvedUnits = (prevState, state, action) => {
  if (action?.type !== 'COMPLETE_PHASE' || selectPhase(prevState) !== PHASES.SUPPLY) {
    return [];
  }
  const prevUnits = selectUnits(prevState) || [];
  const units = selectUnits(state) || [];
  if (prevUnits === units) {
    return [];
  }
  const unitIds = new Set(units.map((unit) => unit.id));
  return prevUnits.filter((unit) => !unitIds.has(unit.id) && !unit.isSupplyRecruit);
};
